import {combineReducers} from 'redux'

import {all} from 'redux-saga/effects'



import * as auth from 'src/app/modules/auth'

import * as rolePermission from 'src/app/modules/common'

import {globalErrorReducer} from 'src/app/modules/errors/redux/reducer'

import * as profile from 'src/app/modules/profileComponent'

import * as siteModule from 'src/app/modules/siteSettings'

import * as userManagement from 'src/app/modules/userMgmt'

import * as branch from 'src/app/modules/userMgmt/components/branch'

import * as departments from 'src/app/modules/userMgmt/components/departments'

import * as userRole from 'src/app/modules/userMgmt/components/userRoles'



import * as mediaManager from 'src/app/modules/common/components/fileManager'



import * as accountStatus from 'src/app/modules/accountStatus/redux'

import * as emailTemplate from 'src/app/modules/cms/components/emailTemplate/redux'



import MasterDataSlice from './MasterDataOption'



export const rootReducer = combineReducers({

  auth: auth.reducer,

  globalError: globalErrorReducer,

  smtp: siteModule.smtp.reducer,

  key: siteModule.key.reducer,

  groupSetting: siteModule.groupSetting.reducer,

  settingType: siteModule.settings.reducer,

  userManagement: userManagement.reducer,

  module: siteModule.module.reducer,

  permission: rolePermission.reducer,

  place: rolePermission.placeReducer,

  role: userManagement.roles.reducer,

  userRoles: userRole.reducer,

  departments: departments.reducer,

  branch: branch.reducer,

  profile: profile.reducer,



  emailTemplate: emailTemplate.reducer,



  mediaManager: mediaManager.reducer,



  contactPerson: siteModule.contactPerson.reducer,






  allMasterDataOptions: MasterDataSlice,



  accountStatus: accountStatus.reducer,

})



export type RootState = ReturnType<typeof rootReducer>



export function* rootSaga() {

  yield all([

    auth.saga(),

    siteModule.smtp.saga(),

    siteModule.key.saga(),

    siteModule.settings.saga(),

    siteModule.groupSetting.saga(),

    siteModule.module.saga(),

    userRole.saga(),

    departments.saga(),

    branch.saga(),

    rolePermission.saga(),

    userManagement.saga(),

    userManagement.roles.saga(),

    profile.saga(),



    emailTemplate.saga(),



    mediaManager.saga(),



    siteModule.contactPerson.saga(),






    accountStatus.saga(),

  ])

}

